require("./loader.js");
require("./WinTextController.js");
require("./game.js");
require("./gameController.js");
require("./ui/settingsMenu.js");
require("./ui/BPsettingsMenuButton.js");
require("./freespinsIntro.js");
require("./helperFunctions.js");
require("./freespins.js");
require("./pixi-spine.js");
require("./spine.js");
require("./particleManager.js");
require("./winlineAnimator.js");
require("./colourBox.js");
require("./screenDimObject.js");
require("./bigWin.js");
require("../../node_modules/hammerjs/hammer.min.js");
require("./musicManager.js");
require("./goldenBetToggle.js");
require("./decreaseStakeButton.js");
require("./increaseStakeButton.js");
require("./hbcVolumeButton.js");
require("./ui/gameStakeSelection.js");
require("./ui/BPautoplayManager-ext.js");
require("./ui/BPgameHistoryButton.js");
require("./winAnimations/freespinsMultiplierAnim.js");
require("./ui/sideMenu.js");
require("./ui/BPsideMenuButton.js");
require("./ui/settingSound.js");
require("./featureOutroPopup.js");
require("./ui/BPgameRulesStringButton.js");
require("./ui/BPfullscreenButton.js");
require("./ReelSpinnerVisualSCS.js");
require("./ReelSpinnerVisualStacked.js");
require("./winAnimations/movieSymbolAnimator.js");
require("./winAnimations/oversizedSymbolAnimator.js");
require("./winAnimations/SymbolLandAnimator.js");
require("./winAnimations/symbolAnimator.js");
require("./shaker.js");
require("./ui/buyBonusButton.js");
require("./ui/buyBonusPopup.js");
require("./ui/GameSlamStopButton.js");
require("./ui/skipWinsButton.js");
require("./ui/BPoptionsButtonEx.js");
require("./messageBox.js");
require("./cashLinkFeature.js");
require("./wildWolfDisplay.js");
require("./potsContainer.js");
require("./freespinsRetriggerPopup.js");
require("./cashLinkIntro.js");
require("./WinController.js");
require("./ScrollContainer.js");
require("./valueOverlays.js");
require("./valuesSpin.js");
require("./valuesMoons.js");
require("./powerPackAwardDisplay.js");
require("../../libs/reflex-library/src/lib/gsap.min.js");
require("../../libs/reflex-library/src/lib/gsapPixiPlugin.js");
